import { rem } from 'polished';
import { Link as ReactLink } from 'react-router-dom';
import styled from 'styled-components';

import { gradient } from '../../styles';

export const Link = styled(ReactLink)`
  ${gradient};

  width: fit-content;
  position: relative;
  padding: ${rem(14)} ${rem(12)} ${rem(14)} ${rem(51)};
  font-size: ${rem(14)};
  font-weight: 500;
  border-radius: ${rem(12)};
  border: ${rem(1)} solid
    ${({ theme }) => theme.colors.book.findMatchButton.border};
  display: block;
  text-decoration: none;

  &,
  &:hover,
  &:focus {
    color: ${({ theme }) => theme.colors.book.findMatchButton.text};
  }

  img {
    width: ${rem(31)};
    position: absolute;
    top: ${rem(12)};
    left: ${rem(12)};
  }

  svg {
    position: relative;
    top: ${rem(3)};
    margin-left: ${rem(8)};
  }
`;
